const getLastNonIdleExecutionInterval = (store) => {
  return store.lastNonIdleExecutionInterval;
};

export { getLastNonIdleExecutionInterval };
